import WarnHierarchyLevel from './warnHierarchyLevel.js';
import childrenMatcher from '../../components/childrenMatcher.js';
import Content from '../../content.js';

var PhoneMask = getModule('IO.Util.PhoneMask'),
  New = Content.extend({
    dom: {
      COUNTRY_SELECT: '.country-select',
      PHONE_FIELD: '.phone-field',
      SELECT2_FIELD: '.select2select',
      SELECTS: '.select2select',
      TIMEZONE_FIELD: '.timezone-field',
      NODE_SELECT: '#store_node_id',
      HOSTNAME_WARNING: '#no-host-warning',
      SAVE_BUTTON: '.io-form-action-save',
      STORE_FORM: '.store-form',
    },

    events: function () {
      var events = {};

      events['change ' + this.dom.COUNTRY_SELECT] = '_updatePhoneMask';
      events['change ' + this.dom.NODE_SELECT] = '_handleHostnameWarning';
      events['submit ' + this.dom.STORE_FORM] = '_beforeSave';
      return events;
    },

    render: function () {
      var $selects = this.$(this.dom.SELECTS),
        selectedCountry = this.$(this.dom.COUNTRY_SELECT).val(),
        $nodeSelect = this.$(this.dom.NODE_SELECT),
        mask = PhoneMask.get(selectedCountry);

      $nodeSelect.select2(
        window.select2Defaults({
          allowClear: true,
          placeholder: 'None',
          includeBlank: true,
        }),
      );

      $selects.select2();
      this.$(this.dom.PHONE_FIELD).inputmask(mask, PhoneMask.opts);
      this._handleHostnameWarning();

      $(this.dom.TIMEZONE_FIELD).select2(
        window.select2Defaults({
          allowClear: true,
          placeholder: 'Select a timezone',
          matcher: childrenMatcher,
        }),
      );
    },

    _updatePhoneMask: function (e) {
      var $target = $(e.currentTarget),
        $form = $target.closest('form'),
        mask = PhoneMask.get($target.val());

      $form.find(this.dom.PHONE_FIELD).inputmask(mask, PhoneMask.opts);
    },

    _handleHostnameWarning: function () {
      var select = $(this.dom.NODE_SELECT),
        noStore = select.val() === null || select.val() === '';

      if (select.data('warning-when-empty') === true && noStore) {
        select.parents('tr').addClass('pref-diff');
        $(this.dom.HOSTNAME_WARNING).removeClass('hidden');
      } else {
        select.parents('tr').removeClass('pref-diff');
        $(this.dom.HOSTNAME_WARNING).addClass('hidden');
      }
    },

    _beforeSave: function () {
      if (!$(this.dom.STORE_FORM).hasClass('hierarchy-impact-yes')) {
        new WarnHierarchyLevel(
          this.dom.STORE_FORM,
          this.$el.find('.HierchyNodeSelectorContainer input').val(),
        );
        return false;
      }

      return true;
    },
  });

module.exports = New;
